module.exports = {
      id: "ic-ohlc-grayscale-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-ohlc-grayscale-usage",
      toString: function () {
        return this.url;
      }
    }